import axios from "axios";
import { useState, useEffect } from "react";
import { useParams, NavLink } from "react-router-dom";
import { List, Rate } from "antd";
import PerformanceChart from "../components/user/performanceChart";
import { UserOutlined } from "@ant-design/icons";

function User() {
  const [user, setUser] = useState({});
  const [userScenarios, setUserScenarios] = useState([]);
  const [message, setMessage] = useState("");
  const [messageResult, setMessageResult] = useState("");
  const { id } = useParams();

  const sendMessage = async () => {
    axios
      .post("https://api.projectrere.org/User/AddMessage", {
        username: "",
        userId: id,
        message: message,
      })
      .then(function (response) {
        console.log(response.status);
        if (response.status === 200) {
          setMessageResult("Message sent successfully!");
        }
        setTimeout(() => {
          setMessageResult("");
          setMessage("");
        }, 3000);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const handleChange = (e) => {
    setMessage(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    sendMessage();
  };

  useEffect(() => {
    const fetchData = async () => {
      const response = await axios.get(
        "https://api.projectrere.org/User/GetUser/?Id=" + id
      );
      setUser(response.data);
      console.log("USER", response.data);
    };
    fetchData();
  }, []);

  return (
    <main>
      <header
        className="ms-1"
        style={{ display: "flex", justifyContent: "space-between" }}
      >
        <h1>User Detail</h1>
        <div>
          <form onSubmit={handleSubmit} className="msg-form">
            <input
              className="msg-input"
              type="text"
              placeholder="enter your message..."
              onChange={handleChange}
              value={message}
            />
            <button type="submit" className="msg-btn">
              Send
            </button>
          </form>
          <span className="msg-result" data-value={messageResult}>
            {messageResult}
          </span>
        </div>
      </header>
      <section className="user">
        <div className="wrapper">
          <div className="card">
            <div className="info">
              {/* <img
                src={"./images/users/" + user.picture}
                className="profile-photo"
              /> */}
              <UserOutlined className="user-icon" />
              <div>
                <h2>{user.title}</h2>
                <p>{user.country}</p>
                <p>
                  Completed Rate:&nbsp;
                  <strong>                   
                      {user.completedScore}%
                  </strong>
                </p>
              </div>
            </div>
            <div className="stats">
              <PerformanceChart data={user.scenarios} />
            </div>
          </div>
          <div className="list">
            <List
              pagination={("both", "center")}
              dataSource={user.scenarios}
              renderItem={(item, index) => (
                <List.Item className="list-item">
                  <List.Item.Meta
                    title={
                      <NavLink
                        to={`/scenarios/${item.id}`}
                      >
                        {item.title}
                      </NavLink>
                    }
                    description={item.description}
                  />
                  <div>
                    {" "}
                    <Rate
                      disabled
                      allowHalf
                      count={3}
                      defaultValue={item.score}
                    />
                  </div>
                </List.Item>
              )}
            />
          </div>
        </div>
      </section>
    </main>
  );
}

export default User;
